import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
    const [auth, setAuth] = useState({
        token: null,
        userData: null,
    });
    const navigate = useNavigate();

    useEffect(() => {
        const token = localStorage.getItem('token');
        if (token) {
            setAuth(prev => ({ ...prev, token }));
        }
    }, []);

    const setUserData = (userData) => {
        setAuth(prevAuth => ({ ...prevAuth, userData }));
    };

    const logout = useCallback(() => {
        localStorage.removeItem('token'); // Clear the token from localStorage
        setAuth({ token: null, userData: null }); // Reset the context
        navigate('/'); // Redirect to the homepage or login page
    }, [navigate]);

    return (
        <AuthContext.Provider value={{ auth, setAuth, setUserData, logout }}>
            {children}
        </AuthContext.Provider>
    );
};

export const useAuth = () => useContext(AuthContext);
